export default "__VITE_ASSET__DDKWDs$Z__"